// Mindspace Polish locations should show local currency symbol
// Refer from https://stackoverflow.com/questions/37195208/browser-intl-numberformat-not-displaying-currency-symbols-correctly

function getCustomLocaleFromCurrency(currency: string | null) {
  switch (currency) {
    case "PLN":
      return "pl";
    default:
      return null;
  }
}

export function formatCurrency(
  amount: number,
  currency: string | null,
  locale?: string,
  minimumFractionDigits: number = 0
) {
  const amountHasOneDecimal =
    Number(amount).toString().split(".")[1]?.length === 1;

  const customLocale = getCustomLocaleFromCurrency(currency) || locale;
  return new Intl.NumberFormat(customLocale, {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: amountHasOneDecimal ? 2 : minimumFractionDigits,
  }).format(amount);
}
